<template>
  <div class="wrapper">
    <el-row>
      <el-col class="page-header">
        <el-page-header @back="goBack" content="窜货明细"> </el-page-header>
      </el-col>
    </el-row>

    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item prop="waringFlag" label="窜货时间">
          <el-date-picker
            v-model="searchDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="cyan" icon="el-icon-search" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="list" border style="width: 100%" v-loading="loading">
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="productName"
        min-width="150"
        label="物料信息"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="productCreateTime"
        min-width="120"
        label="生产日期"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        min-width="150"
        label="扫码时间"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        min-width="150"
        label="扫描地点"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="traceCode"
        min-width="150"
        label="追溯码"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="agentCompanyName"
        min-width="150"
        label="所属经销商"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="targetAddress"
        min-width="150"
        label="应在地区"
        align="center"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :page-sizes="[10, 15, 20]"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    ></el-pagination>
  </div>
</template>

<script>
import { statisticsDetailList } from "@/common/api.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      listForm: {
        pageSize: 10,
        pageNum: 1,
        productId: "",
        companyId: "",
        startDate: null,
        endDate: null,
      },
      productId: "",
      companyId: "",
      searchDate: null,
      productName: "",
      total: 0,
      list: [],
      productList: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      statisticsDetailList(params).then((res) => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.list = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    goBack() {
      this.$router.go(-1); //返回上一层
    },
    searchList() {
      console.log(this.searchDate);
      if (this.searchDate) {
        this.listForm.startDate = this.searchDate[0];
        this.listForm.endDate = this.searchDate[1];
      } else {
        this.listForm.startDate = "";
        this.listForm.endDate = "";
      }
      this.listForm.pageNum = 1;
      this.getPageList();
    },
    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
    // 搜索框重置
    reset() {
      this.$nextTick(() => {
        this.listForm = {
          pageSize: 10,
          pageNum: 1,
          startDate: null,
          endDate: null,
          productId: this.productId,
          companyId: this.companyId,
        };
        this.searchDate = null;
        this.$refs["listForm"].resetFields();
        this.getPageList();
      });
    },
  },
  created() {},
  mounted() {
    this.listForm.productId = this.productId = this.$route.params.productId;
    this.listForm.companyId = this.companyId = this.$route.params.companyId;
    this.getPageList();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;

    .el-select {
      width: 100%;
    }
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
  }
  .code-detail .el-form-item {
    margin-bottom: 0;
  }
  /deep/ .el-autocomplete-suggestion {
    min-width: 100%;
    width: auto !important;
  }
  .page-header {
    padding: 15px 10px;
    border-radius: 6px;
    background-color: #ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/feelingInfo/feelingDetails.vue